<template>
    <div class="mediver-login-container">
        <div class="mediver-login-logo">
            <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="login-logo-img" />
        </div>
        <form class="mediver-login-box" @submit.prevent="login">
            <input
                v-model="email"
                @input="email = $event.target.value.replace(/\s/g, '')"
                type="text"
                class="login-input"
                placeholder="이메일"
                autocomplete="email"
                maxlength="200"
            />
            <input
                v-model="password"
                @input="password = $event.target.value.replace(/\s/g, '')"
                type="password"
                class="login-input"
                placeholder="비밀번호"
                autocomplete="current-password"
                maxlength="30"
            />
            <div class="login-options-row">
                <div class="login-options">
                    <label class="auto-login"><input type="checkbox" v-model="saveLogin" /> 로그인 정보 저장</label>
                </div>
                <div class="login-options">
                    <label class="auto-login"><input type="checkbox" v-model="autoLogin" /> 자동로그인</label>
                </div>
            </div>
            <button type="submit" class="login-btn">로그인</button>
            <div v-if="error" class="login-error">{{ error }}</div>
        </form>
    </div>
</template>
<script>
    import api, { urls }    from '@/api'
    import { useAuthStore } from '@/stores/auth'

    export default {
        name: 'Login',
        data() {
            return {
            email: '',
            password: '',
            error: '',
            autoLogin: false,
            saveLogin: false,
            showIDModal: false,
            showPasswordModal: false,
            showRegisterModal: false,
            authStore: null,
            }
        },
        created() {
            const savedEmail = localStorage.getItem('savedEmail')
            if (savedEmail) {
            this.email = savedEmail
            this.saveLogin = true
            }

            // ✅ require 말고 정식 import로 store 생성
            try {
            this.authStore = useAuthStore()
            } catch (error) {
            console.error('Auth store initialization failed:', error)
            }
        },

        methods: {
            login() {
            api.post(urls.login.login, { email: this.email, password: this.password })
                .then((response) => {
                const data = response.data

                if (data.token) {
                    localStorage.setItem('accessToken', data.token)

                    // axios 기본 헤더 설정
                    api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`

                    // store에 setToken이 있으면 같이 반영(선택)
                    if (this.authStore?.setToken) this.authStore.setToken(data.token)
                    if (this.authStore?.setUser && data.user) this.authStore.setUser(data.user)

                    this.error = ''

                    // 로그인 정보 저장
                    if (this.saveLogin) localStorage.setItem('savedEmail', this.email)
                    else localStorage.removeItem('savedEmail')

                    // 자동로그인 관련(기존 로직 유지)
                    if (this.autoLogin) {
                        localStorage.setItem('autoLogin', 'true')
                        const refreshToken = data.refreshToken
                    if (refreshToken) localStorage.setItem('refreshToken', refreshToken)
                    } else {
                        localStorage.removeItem('autoLogin')
                        localStorage.removeItem('refreshToken')
                    }

                    this.$router.push('/main')
                } else {
                    this.error = data.error || '아이디 또는 비밀번호가 올바르지 않습니다.'
                }
            })
                .catch((err) => {
                this.error = '로그인 중 오류가 발생했습니다.'
                console.error(err)
                })
            },
        },

        async mounted() {
            const preventAutoLogin  = localStorage.getItem('preventAutoLogin')
            const savedAutoLogin    = localStorage.getItem('autoLogin')

            if (savedAutoLogin === 'true') {
                this.autoLogin = true
                const refreshToken = localStorage.getItem('refreshToken')

                if (refreshToken) {
                    if (preventAutoLogin === 'true') {
                        localStorage.removeItem('preventAutoLogin')
                        return
                    }

                    try {
                            const result = await this.authStore.refreshAccessToken({ refreshToken })
                            if (result) this.$router.push('/main')
                    } catch (err) {
                        localStorage.removeItem('refreshToken')
                        localStorage.removeItem('autoLogin')
                        this.autoLogin = false
                    }
                }
            }
        },
    }
</script>


